import { render } from "./TrashPage.vue?vue&type=template&id=6cf2b92e"
import script from "./TrashPage.vue?vue&type=script&lang=js"
export * from "./TrashPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__